import React from 'react';
import classes from './style.module.scss';
import Modal from '~/app/common/Modal';
import Header from './Header';
import Form from './Form';
import { TrainingDetail } from '~/training/types';

export interface ApproveTrainingProps {
  open: boolean
  status: TrainingDetail['status']
  onClose: () => void
}

export type ApproveTrainingComponent = React.FC<ApproveTrainingProps>;

const ApproveTraining: ApproveTrainingComponent = ({ open, status, onClose }) => {

  return (
    <Modal className={classes['approveTrainingModel']} open={open} onClose={onClose} position={'bottom'}>
      <Header status={status} />
      <Form onClose={onClose} status={status} />
    </Modal>
  );
};

export default ApproveTraining;